package ru.arty_bikini.crm_frontend.ui.bootstrap

object Collapse {
    private var id: Int = 1

    fun nextId(): String {
        id++;
        return "collapse-id-$id"
    }
}